{
  "Accessibility Menu": "ਪਹੁੰਚ ਮੇਨੂ",
  "Reset settings": "ਸੈਟਿੰਗਾਂ ਰੀਸੈਟ ਕਰੋ",
  "Close": "ਬੰਦ ਕਰੋ",
  "Content Adjustments": "ਸਮੱਗਰੀ ਸੰਸ਼ੋਧਨ",
  "Adjust Font Size": "ਫੋਂਟ ਆਕਾਰ ਅਨੁਕੂਲਿਤ ਕਰੋ",
  "Highlight Title": "ਸਿਰਲੇਖ ਹਾਈਲਾਈਟ ਕਰੋ",
  "Highlight Links": "ਲਿੰਕ ਹਾਈਲਾਈਟ ਕਰੋ",
  "Readable Font": "ਪੜ੍ਹਨਯੋਗ ਫੋਂਟ",
  "Color Adjustments": "ਰੰਗ ਸੰਸ਼ੋਧਨ",
  "Dark Contrast": "ਗੂੜ੍ਹਾ ਵਿਰੋਧ",
  "Light Contrast": "ਹਲਕਾ ਵਿਰੋਧ",
  "High Contrast": "ਉੱਚਾ ਵਿਰੋਧ",
  "High Saturation": "ਉੱਚਾ ਸੰਤ੍ਰਿਪਤੀ",
  "Low Saturation": "ਘੱਟ ਸੰਤ੍ਰਿਪਤੀ",
  "Monochrome": "ਇਕ ਰੰਗੀ",
  "Contrast": "ਕੰਟਰਾਸਟ",
  "Invert Colors": "ਰੰਗ ਉਲਟਾਓ",
  "Tools": "ਉਪਕਰਨ",
  "Reading Guide": "ਪੜ੍ਹਨ ਗਾਈਡ",
  "Stop Animations": "ਐਨੀਮੇਸ਼ਨ ਰੋਕੋ",
  "Big Cursor": "ਵੱਡਾ ਕਰਸਰ",
  "Increase Font Size": "ਫੋਂਟ ਆਕਾਰ ਵਧਾਓ",
  "Decrease Font Size": "ਫੋਂਟ ਆਕਾਰ ਘਟਾਓ",
  "Letter Spacing": "ਅੱਖਰਾਂ ਦੀ ਦੂਰੀ",
  "Line Height": "ਲਾਈਨ ਦੀ ਉਚਾਈ",
  "Font Weight": "ਫੋਂਟ ਭਾਰ",
  "Dyslexia Font": "ਡਿਸਲੈਕਸੀਆ ਫੋਂਟ",
  "Language": "ਭਾਸ਼ਾ",
  "Open Accessibility Menu": "ਪਹੁੰਚ ਮੇਨੂ ਖੋਲ੍ਹੋ",
  "Widget Settings": "ਵਿਜੈਟ ਸੈਟਿੰਗਜ਼",
  "Widget Position": "ਵਿਜੈਟ ਦੀ ਸਥਿਤੀ",
  "Top Left": "ਉੱਪਰ ਖੱਬੇ",
  "Top Center": "ਉੱਪਰ ਮੱਧ",
  "Top Right": "ਉੱਪਰ ਸੱਜੇ",
  "Center Left": "ਮੱਧ ਖੱਬੇ",
  "Center Right": "ਮੱਧ ਸੱਜੇ",
  "Bottom Left": "ਥੱਲੇ ਖੱਬੇ",
  "Bottom Center": "ਥੱਲੇ ਮੱਧ",
  "Bottom Right": "ਥੱਲੇ ਸੱਜੇ",
  "Screen Reader": "ਸਕ੍ਰੀਨ ਰੀਡਰ",
  "Voice Navigation": "ਆਵਾਜ਼ ਨੈਵੀਗੇਸ਼ਨ",
  "Custom Color": "ਕਸਟਮ ਰੰਗ",
  "Change the site's colors": "ਸਾਈਟ ਦੇ ਰੰਗ ਬਦਲੋ",
  "Backgrounds": "ਪਿਛੋਕੜ",
  "Headings": "ਸਿਰਲੇਖ",
  "Contents": "ਸਮੱਗਰੀ",
  "Reset colors": "ਰੰਗ ਰੀਸੈਟ ਕਰੋ",
  "Image Desaturation": "ਚਿੱਤਰ ਰੰਗ ਘਟਾਓ",
  "Search languages": "ਭਾਸ਼ਾਵਾਂ ਖੋਜੋ",
  "No languages found": "ਕੋਈ ਭਾਸ਼ਾਵਾਂ ਨਹੀਂ ਮਿਲੀਆਂ",
  "Accessibility Profiles": "ਪਹੁੰਚ ਪ੍ਰੋਫਾਈਲ",
  "Motor Impaired": "ਚਲਣ ਵਿੱਚ ਰੁਕਾਵਟ",
  "Big cursor, voice navigation, and no animations.": "ਵੱਡਾ ਕਰਸਰ, ਆਵਾਜ਼ ਨਾਲ ਨੈਵੀਗੇਸ਼ਨ ਅਤੇ ਕੋਈ ਐਨੀਮੇਸ਼ਨ ਨਹੀਂ।",
  "Blind": "ਅੰਨ੍ਹਾ",
  "Screen reader helpers with higher contrast.": "ਵੱਧ ਕਾਂਟ੍ਰਾਸਟ ਵਾਲੇ ਸਕ੍ਰੀਨ ਰੀਡਰ ਸਹਾਇਕ।",
  "Color Blind": "ਰੰਗ ਅੰਨ੍ਹਾ",
  "High contrast palette with desaturated media.": "ਉੱਚ ਕਾਂਟ੍ਰਾਸਟ ਪੈਲੇਟ ਅਤੇ ਘੱਟ ਰੰਗਾਂ ਵਾਲਾ ਮੀਡੀਆ।",
  "Dyslexia": "ਡਿਸਲੇਕਸੀਆ",
  "Friendly font, extra spacing, stronger weight.": "ਸਪਸ਼ਟ ਫੌਂਟ, ਵੱਧ ਖਾਲੀ ਜਗ੍ਹਾ ਅਤੇ ਮੋਟੀ ਲਿਖਤ।",
  "Low vision": "ਕਮਜ਼ੋਰ ਨਜ਼ਰ",
  "Dark contrast and 130% magnification.": "ਗੂੜ੍ਹਾ ਕਾਂਟ੍ਰਾਸਟ ਅਤੇ 130% ਵਧੋਤਰੀ।",
  "Cognitive & Learning": "ਸੰਜ਼੍ਹਾਣੀ ਅਤੇ ਸਿੱਖਣ",
  "Highlights key sections and enables voice help.": "ਮੁੱਖ ਹਿੱਸਿਆਂ ਨੂੰ ਹਾਈਲਾਈਟ ਕਰਦਾ ਹੈ ਅਤੇ ਆਵਾਜ਼ ਸਹਾਇਤਾ ਚਾਲੂ ਕਰਦਾ ਹੈ।",
  "Seizure & Epileptic": "ਦੌਰੇ ਅਤੇ ਮਿਰਗੀ",
  "Stops animations and desaturates imagery.": "ਐਨੀਮੇਸ਼ਨ ਰੋਕਦਾ ਹੈ ਅਤੇ ਚਿੱਤਰਾਂ ਦੀ ਰੰਗਤ ਘਟਾਉਂਦਾ ਹੈ।",
  "ADHD": "ADHD",
  "Reading guide, highlighted links, calmer palette.": "ਪੜ੍ਹਨ ਦੀ ਗਾਈਡ, ਹਾਈਲਾਈਟ ਕੀਤੇ ਲਿੰਕ ਅਤੇ ਸ਼ਾਂਤ ਰੰਗ।",
  "Widget Size": "Widget Size",
  "Default": "Default",
  "Medium": "Medium",
  "Small": "Small",
  "Color Blindness": "Color Blindness",
  "Protanopia": "Protanopia",
  "Deuteranopia": "Deuteranopia",
  "Tritanopia": "Tritanopia",
  "Achromatopsia": "Achromatopsia",
  "Simulates and assists users with color vision deficiencies.": "Simulates and assists users with color vision deficiencies."
}
